module.exports = __webpack_public_path__ + "static/media/Desktop_Purpose_38.7fb97773.png";